/* istanbul ignore file */
// libs
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
// services
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import { COMPETENCIES_URL } from './competencyService';
import CompetencyViewPage from './Show';
import CompetencyContext from './CompetencyContext';

const useCompetencyRoute = () => {
  return createRoute({ listRoute: COMPETENCIES_URL });
};

const CompetencyRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { singleEntityRoute } = useCompetencyRoute();

  return (
    <ProtectedRouter basePath={COMPETENCIES_URL}>
      <Routes>
        <Route
          path={singleEntityRoute}
          element={
            <CompetencyContext permissionToCheck="READ">
              <CompetencyViewPage />
            </CompetencyContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

CompetencyRouter.getRouterPath = () => `${COMPETENCIES_URL}/*`;

export default CompetencyRouter;
